import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { httpReauest } from "../../../utils/httpRequest";
import { toast } from "react-toastify";

const roleLabels = {
  father: {
    en: "Father",
    ar: "الأب",
  },
  mother: {
    en: "Mother",
    ar: "الأم",
  },
  sibling: {
    en: "Sibling or Cousin",
    ar: "أخ / أخت أو ابن/ابنة عم/خال",
  },
  friend: {
    en: "Relative",
    ar: "أحد الأقارب",
  },
};

const TaskModal = ({
  setIsModalOpen,
  currentStage,
  stages,
  setCurrentStage,
  setisLoading,
}) => {
  const [friends, setFriends] = useState([]);
  const [selectedVerifiers, setSelectedVerifiers] = useState([]);
  const [relationHistory, setRelationHistory] = useState({});
  const { t, i18n } = useTranslation();
  const [isFriendModalOpen, setIsFriendModalOpen] = useState(false);

  console.log(relationHistory);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return;

    httpReauest(
      "GET",
      `/user/friends/${user._id}`,
      {},
      {
        "x-access-token": user.token,
      }
    )
      .then((res) => {
        const friendList = res.data.data.map((f) => ({
          _id: f.friendId._id,
          name: f.friendId.name,
          email: f.friendId.email,
          phone: f.friendId.phone,
        }));
        setFriends(friendList);
      })
      .catch((err) => {
        console.error("Error loading friends", err);
      });
  }, []);

  const taskContent =
    i18n.language === "en"
      ? stages[currentStage].task_en
      : stages[currentStage].task;

  const requiredRoles = stages[currentStage].requiredRoles || [];
  const requiredCount = stages[currentStage].verificationNeed;

  const handleSubmit = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user || selectedVerifiers.length !== requiredCount) return;

    try {
      const newHistory = { ...relationHistory };
      const formattedVerifiers = selectedVerifiers.map((id, index) => {
        const role = requiredRoles[index] || "friend";
        newHistory[id] = role;
        return { userId: id, role };
      });

      setRelationHistory(newHistory);

      await httpReauest(
        "POST",
        "/game/task/submit",
        {
          userId: user._id,
          stage: currentStage,
          episode: 1,
          task: stages[currentStage].task,
          task_en: stages[currentStage].task_en,
          requiredVerifiers: formattedVerifiers,
        },
        { "x-access-token": user.token }
      );

      setIsModalOpen(false);
      setisLoading(true);
    } catch (err) {
      console.error("Submit error:", err);
      toast.error(
        i18n.language === "ar"
          ? err?.response?.data?.message?.en
          : err?.response?.data?.message?.en
      );
    }
  };

  const handleFriendSelect = (friendId) => {
    const alreadySelected = selectedVerifiers.includes(friendId);
    if (alreadySelected) {
      // اگر کاربر قبلاً انتخاب شده بود، حذفش کن
      setSelectedVerifiers((prev) => prev.filter((id) => id !== friendId));
    } else if (selectedVerifiers.length < requiredCount) {
      // در غیر این صورت، اگر جا هست اضافه‌اش کن
      setSelectedVerifiers((prev) => [...prev, friendId]);
    }
  };

  return (
    <div
      dir={i18n.language === "en" ? "ltr" : "rtl"}
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
    >
      <div className="bg-white rounded-lg shadow-xl p-6 w-[90%] max-w-xl relative animate-fadeIn">
        <button
          onClick={() => setIsModalOpen(false)}
          className="absolute top-2 right-3 text-gray-700 text-2xl font-bold"
        >
          &times;
        </button>

        <h2 className="text-xl font-bold mb-2 text-gray-800">
          {t("taskmodal_stage")} {currentStage + 1}
        </h2>
        <p className="text-md mb-2 text-gray-700">
          <strong>{t("taskmodal_task")}:</strong> {taskContent}
        </p>
        <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 p-3 rounded-md">
          <p className="font-bold mb-1">
            {t("taskmodal_required_roles_info_title")}
          </p>
          {requiredRoles.map((role, idx) => (
            <p key={idx} className="text-sm">
              {t("taskmodal_required_role")} {idx + 1}:{" "}
              {roleLabels[role][i18n.language]}
            </p>
          ))}
          <p className="text-xs mt-2 text-gray-600">
            {t("taskmodal_required_roles_info_note")}
          </p>
        </div>
        <div className="flex flex-col gap-4 mt-2 ">
          <p className="text-md text-gray-800 font-semibold">
            {t("taskmodal_select_friends")} ({selectedVerifiers.length} /{" "}
            {requiredCount})
          </p>
          <button
            onClick={() => setIsFriendModalOpen(true)}
            className="bg-blue-600 text-white py-2 rounded-lg font-bold hover:bg-blue-700 transition"
          >
            {t("taskmodal_open_friends")}
          </button>

          <button
            onClick={handleSubmit}
            disabled={selectedVerifiers.length !== requiredCount}
            className={`${
              selectedVerifiers.length !== requiredCount
                ? "bg-gray-400"
                : "bg-green-600 hover:bg-green-700"
            } text-white py-2 rounded-lg font-bold transition`}
          >
            {t("taskmodal_submit")}
          </button>
        </div>
      </div>
      {isFriendModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-5 rounded-xl w-[90%] max-w-md max-h-[70vh] overflow-y-auto">
            <h2 className="text-lg font-semibold mb-4">
              {t("taskmodal_select_friends_title")}
            </h2>
            <div className="flex flex-col gap-3">
              {friends.map((friend) => {
                const selected = selectedVerifiers.includes(friend._id);
                const disabled =
                  !selected && selectedVerifiers.length >= requiredCount;

                return (
                  <button
                    key={friend._id}
                    disabled={disabled}
                    onClick={() => handleFriendSelect(friend._id)}
                    className={`flex justify-between items-center p-2 rounded border $${
                      selected ? "bg-green-100 border-green-600" : "bg-white"
                    } $${
                      disabled
                        ? "opacity-40 cursor-not-allowed"
                        : "hover:bg-gray-100"
                    }`}
                  >
                    <div className="text-left">
                      <p className="font-bold text-sm">{friend.name}</p>
                      <p className="text-xs text-gray-600">
                        {friend.email || friend.phone}
                      </p>
                    </div>
                    {selected && (
                      <span className="text-green-600 font-bold text-sm">
                        {t("selected")}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>

            <div className="flex justify-end mt-4 gap-2">
              <button
                onClick={() => setIsFriendModalOpen(false)}
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >
                {t("done")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TaskModal;
